import LocalizedStrings from "react-localization";

export const localize = new LocalizedStrings({
  es: {
    version: "Versión 1.8.6",
    app_name: "Koordine",
    view: "Ver",
    event_type_title: "Tipos de orden de servicio",
    edit_event_type: "Editar tipo de orden de servicio",
    parent_event: "Orden de servicio padre",
    event_type_description:
      "Permite crear tipos con el fin de clasificar y/o agrupar las diferentes órdenes de servicio generadas en la plataforma.",
    personal_description:
      "Permite administrar la información del personal involucrado en la ejecución de las órdenes de servicio programadas.",
    work_team_description:
      "Permite organizar al personal de trabajo en grupos, los cuales se encargarán de la ejecución de las órdenes de servicio programadas.",
    measurement_unit_description:
      "Configura las unidades de medida de los diferentes insumos utilizados durante la ejecución de las órdenes de servicio programadas.",
    supplies_description:
      "Administre todos los insumos que se utilizan durante la ejecución de las órdenes de servicio programadas.",
    clients_description:
      "Gestione la información de todos los clientes a los cuáles le prestará servicios.",
    events_description:
      "Administre la información de las órdenes de servicio programadas.",
    execution_statuses_description:
      "Administre la información de los diferentes estados por los que pasarán los servicios durante su ejecución.",
    form_fields_description:
      "Configure los campos que se utilizarán en los formularios dinámicos para recolectar información.",
    workflow_description:
      "Administre los diferentes flujos de cambio de estado por los que pasarán las órdenes de servicio durante su ejecución.",
    newness_setup_description:
      "Configure las novedades adicionales que se podrán reportar desde la aplicación móvil.",
    reported_newness_description:
      "Visualice las novedades reportadas durante la ejecución de las órdenes de servicio programadas.",
    vehicle_description:
      "Administre la información de los vehículos utilizados en la ejecución de las órdenes de servicio programadas.",
    vehicle_type_description:
      "Defina los diferentes tipos de vehículo disponibles para la ejecución de las órdenes de servicio programadas.",
    operational_area_description:
      "Configure las distintas áreas que componen la empresa y que se encuentran relacionadas con la operación en campo.",
    actions: "Acciones",
    name: "Nombre",
    description: "Descripción",
    background_color: "Color de fondo",
    foreground_color: "Color de letra",
    report_section_title_colors: "Colores del título de sección en reportes",
    modification_date: "Fecha de modificación",
    modified_by: "Modificado por",
    add: "Agregar",
    edit: "Editar",
    delete: "Eliminar",
    main_menu_event_management: "Servicios",
    main_menu_personal_management: "Personal",
    main_menu_supply_management: "Insumos",
    main_menu_client_management: "Clientes",
    main_menu_proceedings: "Expedientes",
    main_menu_contractor_management: "Contratistas",
    main_menu_vehicle_management: "Vehículos",
    main_menu_user_management: "Usuarios",
    main_menu_process_management: "Parametrización",
    main_menu_quotation_management: "Cotizaciones",
    events: "Órdenes de servicio",
    reported_newness: "Novedades reportadas",
    newness_setup: "Novedades adicionales",
    personal: "Personal",
    work_team: "Equipo de trabajo",
    work_teams: "Equipos de trabajo",
    measurement_unit: "Unidad de medida",
    measurement_units: "Unidades de medida",
    supplies: "Insumos",
    clients: "Clientes",
    client: "Cliente",
    vehicles: "Vehículos",
    users: "Usuarios",
    search_by_name: "Filtrar por nombre",
    cancel: "Cancelar",
    generic_delete_message: "¿Realmente desea eliminar este elemento?",
    event_type: "Tipo de orden de servicio",
    cancel_event_type: "Cancelar tipo de orden de servicio",
    confirm: "Confirmar",
    no_data: "No hay datos",
    back: "Volver",
    next: "Siguiente",
    document_type: "Tipo de documento",
    document_number: "Número de documento",
    full_name: "Nombre completo",
    phone_number: "Teléfono",
    email: "Correo electrónico",
    work_team_name: "Nombre del equipo",
    members: "Integrantes",
    symbol: "Símbolo",
    supply_label: "Insumo",
    city: "Ciudad",
    loading: "Cargando",
    stadistics: "Estadísticas",
    filter_list: "Filtrar listado",
    data: "Datos",
    details: "Detalles",
    code: "Código",
    status: "Estado",
    client_name: "Nombre del cliente",
    reported_by: "Reportado por",
    address: "Dirección",
    department: "Departamento",
    assigned_to: "Asignado a",
    operational_status: "Estado operacional",
    cancel_event: "Cancelar orden de servicio",
    event_cancelation_message: "¿Está seguro de cancelar su ejecución?",
    event: "Orden de servicio",
    cancelled: "Cancelada",
    to_execute: "Por ejecutar",
    in_execution: "En ejecución",
    pending_review: "Pendiente de revisión",
    finished: "Finalizada",
    not_assigned: "No asignada",
    execution_status: "Estado de la ejecución",
    execution_statuses: "Estados de la ejecución",
    status_changes: "Cambios de estado",
    status_change: "Cambio de estado",
    dynamic_form: "Formulario dinámico",
    dynamic_forms: "Formularios dinámicos",
    setup: "Configuración",
    agenda: "Agenda",
    form_fields: "Campos de formulario",
    form_field: "Campo de formulario",
    is_initial_status: "Es estado inicial",
    is_final_status: "Es estado final",
    select_event: "Seleccionar orden de servicio",
    not_finished: "No Finalizada",
    title: "Título",
    field_type: "Tipo de campo",
    mandatory: "Obligatorio",
    visible_on_mobile: "Visible en App móvil",
    allowed_on_mobile: "Habilitado para App móvil",
    process: "Proceso",
    workflow: "Flujo de trabajo",
    workflows: "Flujos de trabajo",
    vehicle_types: "Tipos de vehículo",
    vehicle_type: "Tipo de vehículo",
    additionalnewnesssetup: "Novedades adicionales",
    plate: "Placa",
    technomechanic_review: "Revision técnica",
    assurance: "Seguro",
    vehicle: "Vehículo",
    type: "Tipo",
    need_observation: "Necesita observación",
    additional_newness: "Novedad adicional",
    observations: "Observaciones",
    occurr_time: "Fecha de ocurrencia",
    newness: "Novedad",
    home: "Inicio",
    search_by_title: "Buscar por título",
    save_changes: "Guardar cambios",
    new_event_type: "Nuevo tipo de orden de servicio",
    new_operational_area: "Nueva área operativa",
    edit_operational_area: "Editar área operativa",
    color_explanation:
      "Los colores de letra y fondo permiten la identificación de %1s en los diferentes listados.",
    operational_area: "Área Operativa",
    operational_areas: "Áreas operativas",
    edit_workflow: "Editar flujo de trabajo",
    new_workflow: "Nuevo flujo de trabajo",
    error_no_response_from_server: "No hubo respuesta del servidor",
    error_unexpected: "Ha ocurrido un error inesperado",
    error: "Error",
    ok: "Ok",
    new_execution_status: "Nuevo estado de la ejecución",
    edit_client: "Editar cliente",
    new_client: "Nuevo cliente",
    identification_type: "Tipo de identificación",
    identification: "Identificación",
    contact_name: "Nombre de contacto",
    route_not_found: "¡Lo sentimos! no encontramos lo que estás buscando :(",
    new_event: "Nueva orden de servicio",
    reporter_phone_number: "Teléfono de quien reporta",
    reporter_name: "Nombre de quien reporta",
    reporter_email: "Email de quien reporta",
    gps_longitude: "GPS (Longitud)",
    gps_latitude: "GPS (Latitud)",
    initial_status: "Estado inicial",
    final_status: "Estado final",
    accept: "Aceptar",
    session_expired_title: "Llevas un rato sin actividad",
    session_expired_message:
      "Hemos cerrado la sesión para cuidar tú información.",
    select_filter: "Seleccionar filtro",
    event_code: "Código de la orden de servicio",
    client_identification: "Identificación del cliente",
    start_date: "Fecha de inicio",
    end_date: "Fecha de fin",
    date_range: "Rango de fecha",
    dynamic_form_description:
      "Configure poderosos formularios para recolectar información durante la ejecución de las órdenes de servicio programadas.",
    new_dynamic_form: "Nuevo formulario dinámico",
    edit_dynamic_form: "Editar formulario dinámico",
    cancelation_reason: "Ingrese el motivo de la cancelación",
    edit_event: "Editar orden de servicio",
    municipality: "Corregimiento",
    sidewalk: "Vereda",
    anonym: "Anónimo",
    new: "Nuevo",
    not_asigned: "No asignado",
    no_status: "Sin estado",
    contractor: "Contratista",
    new_contractor: "Nuevo contratista",
    edit_contractor: "Editar contratista",
    contractors: "Contratistas",
    surName: "Nombres",
    lastName: "Apellidos",
    new_personal: "Nuevo personal",
    edit_personal: "Editar personal",
    contractors_description:
      "Administre la información de los contratistas que prestan servicios para la atención de las órdenes de servicio reportadas.",
    new_vehicle_type: "Nuevo tipo de vehículo",
    edit_vehicle_type: "Editar tipo de vehículo",
    new_vehicle: "Nuevo vehículo",
    edit_vehicle: "Editar vehículo",
    soat: "Seguro",
    expected_attention_date: "Fecha estimada de atención",
    new_form_field: "Nuevo campo de formulario",
    edit_form_field: "Editar campo de formulario",
    help_text: "Texto de ayuda",
    field_type_string: "Texto",
    field_type_int: "Entero",
    field_type_double: "Decimal",
    field_type_date: "Fecha",
    field_type_time: "Hora",
    field_type_datetime: "Fecha y hora",
    field_type_signature: "Firma",
    field_type_photo: "Fotografía",
    creation_date: "Fecha de creación",
    edit_team: "Editar equipo de trabajo",
    new_team: "Nuevo equipo de trabajo",
    assigned_by: "Asignado por",
    assignment_date: "Fecha de asignación",
    assigned: "Asignado",
    unassigned: "Desasignado",
    assign_event: "Asignar orden de servicio",
    assign: "Asignar",
    team_member: "Miembro del equipo",
    add_new_team_member: "Agregar nuevo miembro al equipo",
    manage_team_member: "Miembros del equipo",
    resolution: "Acto administrativo",
    resolution_description:
      "Administre la información de los actos administrativos (resoluciones y/o permisos) relacionados a la atención de clientes.",
    new_resolution: "Nuevo acto administrativo",
    edit_resolution: "Editar acto administrativo",
    resolutions: "Actos administrativos",
    new_measurement_unit: "Nueva unidad de medida",
    edit_measurement_unit: "Editar unidad de medida",
    supply: "Insumo",
    new_supply: "Nuevo insumo",
    edit_supply: "Editar insumo",
    new_additional_newness: "Nueva novedad adicional",
    edit_additional_newness: "Editar novedad adicional",
    review_form: "Formulario de revisión",
    logo_alt: "Logo de la plataforma",
    general_information: "Información general",
    back_to_home: "Volver al inicio",
    close: "Cerrar",
    add_field: "Agregar campo",
    add_page: "Agregar página",
    new_page: "Nueva página",
    select_field: "Campo de formulario",
    delete_page: "Eliminar página",
    no_pages_added: "No hay páginas añadidas al formulario.",
    page: "Página",
    add_form_field: "Agregar campo de formulario",
    client_information: "Información del cliente",
    status_historical: "Histórico de estados",
    evidences: "Evidencias",
    event_relation: "Relacionado a orden de servicio Nro.",
    quantity: "Cantidad",
    low_battery: "Batería baja",
    normal_battery: "Batería normal",
    gps_on: "GPS Activo",
    gps_off: "GPS Inactivo",
    data_on: "Datos móviles activos",
    data_off: "Datos móviles inactivos",
    shutdown: "Apagado del dispositivo",
    airplane_on: "Modo avión activado",
    airplane_off: "Modo avión desactivado",
    photography: "Fotografía",
    video: "Video",
    audio: "Audio",
    evidence_type: "Tipo de evidencia",
    link: "Enlace",
    download: "Descargar",
    add_newness: "Agregar Novedad",
    add_supply: "Agregar Insumo",
    add_evidence: "Agregar Evidencia",
    add_status_change: "Agregar cambio de estado",
    view_gallery: "Ver galería",
    gallery: "Galería",
    newnesses: "Novedades",
    current_status: "Estado actual",
    new_status: "Nuevo estado",
    supplies_used_on_event:
      "Insumos utilizados durante la ejecución de la orden de servicio.",
    evidences_description:
      "En este apartado, encontrará toda la evidencia recolectada durante la ejecución de la orden de servicio.",
    status_changes_description:
      "Línea de tiempo de los cambios de estado de la orden de servicio.",
    must_fill_dynamic_form: "Deberá diligenciar el formulario",
    sign_in: "Inicio de sesión",
    password: "Contraseña",
    enter: "Iniciar sesión",
    username: "Nombre de usuario",
    minimum_battery_level: "Nivel mínimo de batería (Porcentaje)",
    minimum_battery_level_description:
      "Valor que será considerado como mínimo para reportar la novedad de nivel bajo de batería.",
    minimum_time_between_gps_updates: "Intervalo de actualización (GPS)",
    minimum_time_between_gps_updates_description:
      "Indica el tiempo mínimo en el que se solicitará una nueva actualización de GPS.",
    minimum_distance_change_in_meters: "Distancia actualización (GPS)",
    minimum_distance_change_in_meters_description:
      "Distancia en la que se solicitará una actualización de GPS.",
    maximum_photo_evidences_per_event: "Fotos por orden de servicio",
    maximum_photo_evidences_per_event_description:
      "Indica la cantidad máxima de evidencias fotográficas por orden de servicio.",
    maximum_audio_evidences_per_event: "Audios por orden de servicio",
    maximum_audio_evidences_per_event_description:
      "Indica la cantidad máxima de evidencias de audio por orden de servicio.",
    maximum_video_evidences_per_event: "Videos por orden de servicio",
    maximum_video_evidences_per_event_description:
      "Indica la cantidad máxima de evidencias de vídeo por orden de servicio.",
    application_base_url: "URL base",
    application_base_url_description: "URL del servidor de sincronización.",
    time_to_request_events:
      "Intervalo de actualización de órdenes de servicio (Segundos)",
    time_to_request_events_description:
      "Indica el tiempo en el que se va solicitar la actualización de las órdenes de servicio programadas.",
    device_setup: "Configuración del dispositivo",
    invalid_credentials: "Credenciales inválidas",
    check_credentials:
      "Error: Por favor, verifique su nombre de usuario y/o contraseña",
    edit_page: "Editar página",
    page_name: "Nombre de la página",
    page_name_description:
      "Ingrese el nombre que se mostrará en el formulario.",
    maximum_audio_time: "Tiempo máximo de audio (Segundos)",
    maximum_audio_time_description:
      "Indica el tiempo máximo de grabación de audio como evidencia",
    field_type_boolean: "Sí/No (Booleano)",
    field_type_combobox: "Selector",
    yes: "Sí",
    no: "No",
    true_value: "Texto a mostrar (Sí)",
    false_value: "Texto a mostrar (No)",
    open: "Abrir",
    synchronization_interval: "Intervalo de sincronización (Segundos)",
    synchronization_interval_description:
      "Indica el tiempo en el que se ejecutará cada proceso de sincronización.",
    profiles: "Perfiles",
    profile: "Perfil",
    new_profile: "Nuevo Perfil",
    add_profile: "Agregar perfil",
    edit_profile: "Editar perfil",
    module: "Módulo",
    restriction: "Restricción",
    access: "Acceso",
    profile_description:
      "Administre la información de los perfiles de usuario y sus restricciones",
    sign_in_base_url: "URL base para inicio de sesión",
    sign_in_base_url_description:
      "Indica la URL utilizada para enviar las solicitudes de inicio de sesión.",
    sign_out: "Cerrar sesión",
    sign_out_message:
      "Estás a punto de salir del sistema. Esperamos que regreses pronto.",
    total: "Total",
    execution_times: "Tiempo de ejecución",
    execution_times_description:
      "Tiempo de permanencia de la orden de servicio en cada estado.",
    restrictions: "Restricciones",
    days: "Día(s)",
    hours: "Hora(s)",
    minutes: "Minuto(s)",
    seconds: "Segundo(s)",
    graph: "Gráfico",
    users_description:
      "Administre la información de los usuarios que podrán tener acceso al sistema",
    new_user: "Nuevo usuario",
    edit_user: "Editar usuario",
    manage_user_profile: "Administrar perfil de usuario",
    confirm_password: "Confirmar contraseña",
    modify_user_name: "Modificar nombre de usuario",
    modify_password: "Modificar contraseña",
    role: "Rol",
    no_changes: "No se realizaron cambios.",
    personal_for_field_work: "Personal de trabajo en campo",
    password_restriction:
      "La contraseña debe tener entre 6 y 20 caracteres, contener por lo menos una letra minúscula, una letra mayúscula, un número y un caracter especial.",
    valid_password: "Contraseña válida.",
    password_no_match: "Las contraseñas no coinciden.",
    dashboard: "Estadísticas generales",
    dashboard_description:
      "Muestra información consolidada sobre el estado general de la ejecución de órdenes de servicio en el rango de: ",
    operational_status_analytics: "Órdenes de servicio por estado operacional ",
    execution_status_analytics: "Órdenes de servicio por estados de ejecución",
    events_by_distribution_on_personal: "Asignación de órdenes de servicio por personal",
    events_by_state_analytics: "Órdenes de Servicio Reportadas por región",
    events_by_city_analytics: "Órdenes de Servicio Reportadas por ciudad",
    events_by_clients_analytics: "Órdenes de Servicio Reportadas por cliente",
    gps: "GPS",
    technical_concept: "Notas",
    finish_review: "Finalizar orden de servicio",
    positions: "Cargos",
    position: "Cargo",
    position_description:
      "Administre la información de los cargos disponibles en la empresa.",
    new_position: "Nuevo cargo",
    edit_position: "Editar cargo",
    without_status: "Sin estado",
    without_name: "Sin nombre",
    view_image: "Ver imagen",
    finish_review_warning:
      "No se podrán realizar más cambios después de finalizada la orden de servicio.",
    combobox_helper_text:
      "Para agregar más de una opción, separarlas con punto y coma (;).",
    options: "Opciones",
    conclusions: "Conclusiones",
    related_evidence: "Evidencia relacionada",
    add_technical_concept: "Agregar nota",
    proceeding: "Expediente",
    filter: "Filtrar",
    external_user: "Cliente",
    driver: "Conductor",
    start: "Inicio",
    end: "Fin",
    activity_description: "Observaciones",
    generate_inform: "Generar reporte",
    report: "Reporte",
    format: "Formato",
    print_service_order: "Imprimir orden de servicio",
    edit_proceeding: "Editar expediente",
    proceedings: "Expedientes",
    proceeding_description: "Administre la información de los expedientes.",
    new_proceeding: "Nuevo expediente",
    visit_report: "Reporte de orden de servicio",
    finished_without_conslusions: "Finalizado sin conclusiones.",
    multiline_text: "Texto multilínea",
    date_range_error:
      "Fecha estimada de atención (inicio) no puede ser mayor a fecha estimada de atención (fin).",
    upload_image: "Seleccionar imagen",
    edit_value: "Editar valor",
    select_value: "Seleccione un valor",
    file: "Archivo",
    uploading_image: "Cargando imagen",
    please_wait: "Por favor espere",
    executed_manually: "Ejecutado manualmente",
    required_form: "Formulario requerido",
    no_form_fields: "No hay campos",
    generate_pdf: "Generar PDF",
    area: "Área",
    subdirectorate_environmental_management: "ORDEN DE SERVICIO",
    generate_original_report: "Informe original",
    generate: "Generar",
    select_file: "Seleccionar archivo",
    warning_evidence_input_file: "Solo archivos con extensión",
    image: "Imagen",
    processing: "Procesando",
    attach_file: "Adjuntar archivo",
    delete_evidence: "Eliminar evidencia",
    evidence: "Evidencia",
    dashboard_events:
      "Muestra estadísticas de la ejecución de las órdenes de servicio. Sólo tiene en cuenta el filtro de 'Rango de fecha'.",
    generate_current_report_with_changes: "Informe actual (con modificaciones)",
    technical_concept_uppercase: "CONCEPTO TÉCNICO",
    visit_auto_assign: "Auto-asignación de órdenes de servicio",
    visit_auto_assign_description:
      "Habilita o deshabilita la posibilidad de que el personal de campo pueda auto-asignarse órdenes de servicio.",
    warehouses: "Bodegas",
    warehouse_description:
      "Administre la información de las bodegas disponibles para la empresa, con ello podrá organizar de mejor manera su inventario.",
    edit_warehouse: "Editar Bodega",
    new_warehouse: "Nueva Bodega",
    warehouse: "Bodega",
    form_signature: "Firma de formulario",
    additional_data: "Datos adicionales",
    list: "Listado",
    enter_new_field_name: "Ingrese el nombre del nuevo dato",
    error_no_event_type: "Debe seleccionar un tipo de orden de servicio",
    error_no_fields:
      "No hay campos adicionales configurados para el tipo de orden de servicio",
    tooltip_close_menu: "Cerrar menú",
    tooltip_open_menu: "Abrir menú",
    tooltip_logout: "Cerrar sesión",
    tooltip_device_settings: "Configuración del dispositivo",
    tooltip_detail: "Ver detalle",
    tooltip_delete: " Eliminar",
    tooltip_cancel: "Cancelar orden de servicio",
    tooltip_user: "Usuario",
    not_assigned_masc: "No asignado",
    administrative_flow: "Flujo administrativo",
    status_change_only_available_on_web: "Sólo para la web.",
    service_value: "Valor del servicio",
    spare_parts_value: "Valor insumo(s)",
    earning_spare_parts_value: "Ingreso por insumo(s)",
    spare_parts_real_value: "Valor de compra de insumo(s)",
    original_value: "Valor Original",
    report_sections: "Secciones del reporte",
    client_type: "Tipo de cliente",
    show_gps_value: "Agregar GPS a evidencia",
    show_gps_value_description:
      "Indica si al momento de capturar una evidencia se agregará o no la ubicación GPS en ella.",
    show_gps_city: "Mostrar GPS como ubicación",
    show_gps_city_description:
      "Indica si se utiliza la ubicación GPS para mostrar el nombre de la ubicación",
    show_gps_degrees_minutes_seconds: "Formato de ubicación GPS",
    show_gps_degress_minutes_seconds_description:
      "Indica si la ubicación GPS se representa en grados, minutos y segundos, o sí se representa como coordenadas (latitud y longitud).",
    degrees_minuets_seconds: "Grados, Minutos y Segundos",
    latitude_and_longitude: "Latitud y Longitud",
    create_related_visit: "Crear servicio relacionado",
    related_to: "Relacionada a",
    ignore: "Ignorar",
    new_visit_generated: "¡Se ha generado una nueva orden de servicio!",
    field_evidence_compression: "Nivel de compresión de imagen",
    field_evidence_compression_description:
      "Indica el porcentaje (%) de compresión de las imágenes capturadas como evidencia dentro de la App móvil.",
    field_gps_label_text_color: "Color de letra de marcado de imagen",
    field_gps_label_text_color_description:
      "Indica el color que se usará en la App Móvil para marcar las imágenes de evidencia.",
    not_signed: "No firmado",
    generate_summary: "Generar resumen",
    event_summary: "Resumen de Orden de Servicio",
    total_value: "Valor Total",
    total_approved_additional_costs: "Total aprobado",
    payed: "Pagado",
    payment_date: "Fecha de Pago",
    billed: "Facturado",
    bill_date: "Fecha de Factura",
    bill_code: "Código de factura",
    billing: "Facturación",
    register_bill: "Asociar factura",
    register_payment: "Registrar pago",
    payment_data_udpated: "Información del pago actualizada",
    process_succeeded: "Proceso exitoso",
    not_payed: "No Pagado",
    payment_status: "Estado del Pago",
    bill_registered_successfully: "Factura registrada exitosamente",
    not_billed: "No Facturado",
    without_bill: "Sin Facturar",
    billing_status: "Estado de Facturación",
    warranty_service_not_billable: "Servicio de garantía NO facturable",
    service_not_executed: "Servicio NO realizado",
    not_billable_service: "Servicio NO facturable",
    other: "Otro",
    motivation: "Motivo",
    edit_values: "Editar valores",
    set_service_values: "Asignar valores del servicio",
    service_values: "Valores del servicio",
    form_signatures: "Firmas de Formulario",
    without_payment: "Sin Pago",
    current_value: "Valor actual",
    maximum_value: "Valor Máximo",
    minimum_value: "Valor Mínimo",
    payment_method: "Modo de Pago",
    can_edit: "Podrá continuar editando la información después de finalizada la orden.",
    requests: "Solicitudes",
    quotation_requests: "Solicitudes de cotización",
    quotation_setup: "Configuración de cotización",
    edit_quotation_setup: "Editar configuración de cotización",
    quotation_setup_description:
      "Permite crear diferentes configuraciones para cualquier tipo de cotización que se generen a los clientes.",
    new_quotation_setup: "Nueva configuración de cotización",
    custom_logo: "Logo personalizado",
    auto_event_generation: "Generación de OS",
    edit_quotation_request: "Editar solicitud de cotización",
    quotation_request_description:
      "Crea solicitudes de cotización para gestionar clientes.",
    new_quotation_request: "Nueva solicitud de cotización",
    quotation_request: "Solicitud de cotización",
    quotation_status_generated: "Generada",
    quotation_status_canceled: "Cancelada",
    quotation_status_pending: "Pendiente",
    quotation_status_draft: "Borrador",
    without_client: "Sin cliente",
    first: "Primera",
    last: "Última",
    previous: "Anterior",
    incomes: "Ingresos",
    totalIncome: "Ingreso total",
    totalServiceOrders: "Total de OS",
    new_additional_cost_type: "Nuevo tipo de costo adicional",
    edit_additional_cost_type: "Editar tipo de costo adicional",
    additional_cost_type_title: "Tipos de costo adicional",
    additional_cost_type: "Tipo de costo adicional",
    sale_unit_value: "Valor de venta",
    purchase_unit_value: "Valor de compra",
    generates_additional_cost: "Genera costo adicional",
    additional_cost_type_description:
      "Permite configurar todos los diferentes tipos de costos adicionales que se pueden presentar durante la ejecución de una órden de servicio.",
    generates_technician_payment: "Genera pago al personal",
    payment_mode: "Modo de pago",
    value: "Valor",
    percentage: "Porcentaje (%)",
    fixed_value: "Valor Fijo",
    payment_type: "Tipo de pago",
    payment_type_title: "Tipos de pago",
    payment_type_description:
      "Permite configurar los diferentes tipos de pago realizados al personal por la ejecución de las órdenes de servicio.",
    new_payment_type: "Nuevo tipo de pago",
    edit_payment_type: "Editar tipo de pago",
    settlements_title: "Liquidaciones",
    settlement_description:
      "Genere la liquidación de las órdenes de servicio ejecutadas.",
    settlement_status_pending: "Pendiente",
    settlement_status_approved: "Aprobado",
    settlement_status_rejected: "Rechazado",
    settlement_status_payed: "Pagado",
    settlement_status_partial: "Parcial",
    new_settlement: "Nueva liquidación",
    new_settlement_intro:
      "Para iniciar el proceso de liquidación, tener en cuenta lo siguiente:",
    new_settlement_req_personal:
      "Las órdenes de servicio deben tener asignado un personal.",
    new_settlement_req_status:
      "Las órdenes de servicio deben tener el estado operacional 'Pendiente de revisión' o 'Finalizada'. Es decir, ya debieron ser ejecutadas.",
    new_settlement_req_not_settled:
      "Las órdenes de servicio no han sido liquidadas previamente.",
    settlement_orders_subtitle:
      "Seleccione las órdenes de servicio que se van a incluir en la liquidación.",
    settlement_process_title: "Proceso de liquidación",
    settlement_process_subtitle:
      "Al ejecutar la liquidación se validará cada una de las órdenes de servicio relacionadas y se registrarán los pagos correspondientes al personal de acuerdo a lo configurado en el tipo de orden de servicio.",
    settlement_process_subtitle_additional: "La liquidación podrá visualizarse en la sección de 'Liquidación' dentro del detalle de cada orden de servicio.",
      settlement_request_button: "Solicitar liquidación",
    settlement_request_confirm:
      "¿Está seguro que desea solicitar la liquidación de esta orden de servicio?",
    settlement_overwrite_toggle:
      "Las liquidaciones previas para las órdenes de servicio seleccionadas se rechazarán y serán reemplazadas por esta nueva liquidación.",
    settlement_report_no_settled_details:
      "Sólo se listan las liquidaciones aprobadas y pagadas, si no hay datos presentes puede deberse a que todas las liquidaciones están rechazadas.",
    event_detail_tabs_module: "Detalle de orden de servicio (pestañas)",
    module_access_denied:
      "Este módulo no se encuentra disponible para su usuario. Si necesita acceder a el, por favor contacte con un administrador.",
    module_access_denied_title: "Acceso restringido",
    settlement_in_progress_warning:
      "El proceso de liquidación está en ejecución, por favor no cierre esta ventana hasta que finalice.",
    settlement_results_title: "Resultados",
    settlement_created_success:
      "Se ha creado una nueva liquidación, presione el botón 'Ok' para actualizar el listado.",
    settlement_created_with_not_processed:
      "Algunas órdenes de servicio no pudieron ser procesadas. A continuación encontrará el detalle.",
    settlement_no_orders_to_settle:
      "No se encontraron órdenes de servicio para liquidar.",
    settlement_settled_count_label: "Liquidadas",
    settlement_not_processed_count_label: "No procesadas",
    settlement_error_no_personal_assigned:
      "La orden de servicio no tiene un personal asignado.",
    settlement_error_already_settled:
      "La orden de servicio ya ha sido liquidada.",
    settlement_error_no_payment_types:
      "El tipo de orden de servicio asignado a esta orden de servicio no cuenta con tipos de pagos asignados.",
    settlement_not_created:
      "La liquidación no ha sido creada, a continuación encontrará los motivos por los cuáles no se han liquidado cada una de las órdenes de servicio",
    settlement_unexpected_error:
      "El proceso de liquidación ha fallado por un error inesperado.",
    settlement_errors_accordion: "Errores en la liquidación",
    settlement_settled_orders_accordion: "Órdenes de servicio liquidadas",
    settlement_observation_title: "Observación de la liquidación",
    settlement_orders_added: "Órdenes de servicio agregadas",
    settlement_detail_title: "Liquidación",
    settlement_settled_value: "Valor liquidado",
    settlement_total_settled_value: "Total liquidado",
    settlement_summary_title: "Resumen",
    settlement_total_approved: "Total aprobado",
    settlement_filters_title: "Filtros",
    settlement_clear_filters: "Limpiar filtros",
    settlement_base_value: "Valor base de liquidación",
    settlement_status_changed_by: "Estado cambiado por",
    settlement_concept: "Concepto",
    settlement_origin: "Origen",
    settlement_origin_additional_cost: "Costo adicional",
    settlement_origin_event_type: "Orden de servicio",
    settlement_expand_all: "Expandir todo",
    settlement_collapse_all: "Colapsar todo",
    settlement_total_settled_orders:
      "Total de órdenes de servicio liquidadas",
    settlement_assigned_personal: "Personal asignado",
    settlement_detail_identifier: "Identificador",
    settlement_edit_detail_title: "Editar detalle de liquidación",
    settlement_change_status_title: "Cambiar estado de la liquidación",
    settlement_status_change_message:
      "Esto sólamente modificará las liquidaciones que se encuentran en estado 'Pendiente'.",
    settlement_status_change_success:
      "El estado de la liquidación se ha actualizado correctamente.",
    settlement_payment_confirm_question:
      "¿Desea registrar el pago de la liquidación?",
    settlement_payment_confirm_info:
      "Se modificará el estado de todas las liquidaciones Aprobadas y se aprobarán todos los pagos relacionados en las órdenes de servicio correspondiente.",
    settlement_detail_payment_confirm_info:
      "Se modificará el estado de la liquidación y se aprobarán todos los pagos relacionados en las órdenes de servicio correspondiente.",
    settlement_change_status_tooltip: "Click para cambiar estado de la liquidación",
    settlement_edit_tooltip: "Click para editar liquidación",
    settlement_observation_required:
      "Para modificar la liquidación se debe agregar una observación.",
    payment_types: "Tipos de pago",
    add_payment_type: "Agregar tipo de pago",
    fixed_value: "Valor fijo",
    percentage_value: "Porcentaje",
    additional_costs: "Costos adicionales",
    add_additional_costs_description:
      "Agrega costos adicionales generados durante la ejecución de la orden de servicio.",
    add_additional_cost: "Agregar costo adicional",
    change_additional_cost_status: "Cambiar el estado del costo adicional",
    in_progress: "En proceso",
    approved: "Aprobado",
    rejected: "Rechazado",
    approve: "Aprobar",
    reject: "Rechazar",
    register_payment_to_technician: "Registrar pago al personal",
    payment_to_technician: "Pago al personal",
    payment_registered_successfully: "¡Solicitud de pago registrada correctamente!",
    payment_of: "Pago de",
    pre_orders_title: "Pre-Órdenes",
    pre_orders_description:
      "Visualice todas las pre-órdenes creadas por los usuarios externos.",
    pre_order: "Pre-Orden",
    order_code: "Código de Orden",
    last_update: "Última actualización",
    service_order: "Orden de servicio",
    product_data: "Datos del producto",
    bill_number: "Número de factura",
    service_detail: "Detalle del servicio",
    serial: "Serial",
    model: "Modelo",
    assign_service_order_to: "Asignar orden de servicio a",
    order_number: "Número de orden",
    order_assigned_successfully: "¡Orden asignada correctamente!",
    show_full_screen: "Ver en pantalla completa",
    assign_status_to: "Asignar estado a",
    status_assigned_successfully: "Estado asignado correctamente",
    status_observation: "Observación de estado",
    document: "Documento",
    evidences_by_field: "Evidencias por campo",
    panel_report: "Evidencias en cuadrilla",
    personal_assigned_signature: "Firma Personal Asignado",
    client_signature: "Firma Cliente",
    settlement: "Liquidación",
    signature: "Firma",
    report_type:
      "Tipo de reporte",
    default_value: "Valor por defecto",
    request_signature: "Solicitar firmas",
    evidence_template: "Plantilla de evidencias",
    evidence_template_description:
      "Cree plantillas que permitan conocer cuáles evidencias deben ser capturadas de acuerdo a las diferentes situaciones que se pueden presentar durante la ejecución de las órdenes de servicio.",
    edit_evidence_template: "Editar plantilla de evidencias",
    new_evidence_template: "Nueva plantilla de evidencias",
    search: "Buscar",
    select: "Seleccionar",
    events_search: "Búsqueda de órdenes de servicio",
    error_no_service_order_found: "No se encontró la orden de servicio",
    error_service_order_already_added:
      "Orden de servicio ya se encuentra en la lista",
    register_payment_description:
      "Registre el pago realizado a cada una de las órdenes de servicio ejecutadas.",
    no_payment_info:
      "Presiona el botón 'Agregar +' para registrar información del pago de órdenes de servicio.",
    payment_info: "Información del pago",
    delete_payment_info: "Eliminar información del pago",
    delete_payment_info_confirmation:
      "Se eliminará la información del pago y deberá ingresar la información nuevamente.",
    add_events_to_payment_description:
      "Utilice el botón Seleccionar para agregar las órdenes de servicio, a las cuales desea registrar el pago, y luego presione el botón Guardar Cambios, para guardar la información.",
    finish_register_payment: "Finalizar registro de pago",
    service_orders: "Órdenes de servicio",
    save_payment_confirmation:
      "El pago será relacionado con las órdenes de servicio seleccionadas.",
    continue: "Continuar",
    success_payment_registration_message:
      "La información del pago se ha registrado correctamente.",
    error_saving_payment_info:
      "Error al guardar la información del pago para las siguientes órdenes de servicio",
    edit_bill: "Editar factura",
    related_bills: "Relación de Facturas",
    related_bills_description:
      "Asocie órdenes de servicio a las facturas generadas en su sistema contable.",
    new_bill: "Nueva factura",
    bill: "Factura",
    success_bill_registration: "Asociación de factura realizada correctamente.",
    add_events_to_bill:
      "Utilice el botón 'Agregar', para adicionar al listado las órdenes de servicio que desea relacionar a la factura, y luego presione el botón 'Guardar Cambios', para guardar la información.",
    save_billing_confirmation:
      "La factura se relacionará con las órdenes de servicio seleccionadas.",
    delete_bill_information: "Cancelar edición de factura",
    delete_bill_info_confirmation: "Se cancelará la edición de la factura.",
    continue_editing: "Continuar editando",
    orders_to_relate_to_bill: "OS Por relacionar a la factura",
    orders_related_to_bill: "OS Relacionadas a la factura",
    added_events_to_bill:
      "Utilice el botón 'Registrar pago' para guardar la información del pago de las órdenes relacionadas a la factura.",
    error_no_personal_assigned:
      "Debe asignar un personal para poder registrar el pago.",
    personal_not_assigned: "Personal no asignado",
    calendar: "Calendario",
    calendar_message:
      "Las órdenes de servicio se mostrarán en el calendario teniendo en cuenta la fecha estimada de atención (Inicio y Fin).",
    view_details: "Ver detalle",
    daily_route_title: "Programación",
    daily_route_description:
      "Administre la programación de la ejecución de órdenes de servicio para todo el personal.",
    is_private: "Es privada",
    route_date: "Fecha de ruta",
    edit_route: "Editar Programación",
    new_route: "Nueva Programación",
    route: "Ruta",
    daily_route_service_orders:
      "Al agregar órdenes de servicio a la programación, la fecha estimada de atención y el personal se asignarán automáticamente de acuerdo a lo configurado para la programación.",
    question_save_changes:
      "Se guardarán los cambios realizados a la programación.",
    is_public: "Es pública",
    service_notes: "Notas del servicio",
    error_empty_field: "Este campo es obligatorio",
    company_name: "Razón Social",
    company_information: "Datos de la empresa",
    after_saving_status_change: "después de guardar el cambio de estado.",
    notify_by_email: "Notificar vía correo electrónico",
    emails: "Correo(s) electrónico(s)",
    colors_note: "Los colores de fondo y letra permiten identificar el estado a simple vista.",
    email_notification: "Notificación por correo electrónico",
    notification: "Notificación",
    initial_status_note: "Los estados marcados como 'Inicial', se asignan inmediatamente al crear la orden de servicio (debe estar asignado en un flujo de trabajo).",
    final_status_note: "Los estados marcados como 'Final', se considerarán en la App móvil como el último estado por el cual pasará la orden de servicio, activando la sincronización de datos.",
    emails_note: "Para ingresar más de un correo electrónico utilice punto y coma (;).",
    billable: "Facturable",
    id: "ID",
    register_payment: "Registrar pago",
    notify_when: "Notificar cambio de estado",
    notification_type_web_app: "Siempre",
    notification_type_web: "Sólo si es realizado por la Web",
    notification_type_app: "Sólo si es realizado por la App",
    print: "Imprimir",
    quotation_status_accepted: "Aceptada",
    quotation_status_rejected: "Rechazada",
    requested_by: "Solicitado por",
    contact_number: "Número de contacto",
    origin: "Origen",
    from_web: "Web",
    from_app: "App",
    address_complement: "Complemento de dirección",
    tags: "Etiquetas de búsqueda",
    new_tag: "Nueva etiqueta",
    main_menu_inventory_management: "Inventario",
    inventory_movement_type: "Tipos de movimiento de inventario",
    inventory_movement_type_title: "Tipo de movimiento de inventario",
    inventory_movement_type_description: "Administre los diferentes tipos de movimiento de inventario realizados por su organización, definiendo cuáles son de entrada y cuáles de salida.",
    movement_type: "Tipo de movimiento",
    new_inventory_movement_type: "Nuevo tipo de movimiento de inventario",
    edit_inventory_movement_type: "Editar tipo de movimiento de inventario",
    in: "Entrada",
    out: "Salida",
    inventory_movement_title: "Movimientos de inventario",
    inventory_movement_description: "Realice movimientos de entrada y salida para administrar el inventario.",
    movement_date: "Fecha del movimiento",
    new_inventory_movement: "Nuevo movimiento de inventario",
    movement: 'Movimiento',
    inventory_movement_supplies_message: "Lista de insumos del movimiento de inventario.",
    assignment_history: 'Histórico de asignación',
    search_type: "Tipo de búsqueda",
    error_no_supply_found: "Insumo no encontrado.",
    error_supply_already_added: "Insumo ya se encuentra en la lista",
    supply_search: "Búsqueda de insumos",
    assign_quantity: "Asignar cantidad",
    referenced_by_usage: "Reporta consumo",
    referenced_by_usage_note: "Este tipo de movimiento de inventario se utilizará para reportar el consumo de insumos en una orden de servicio (debería activarse esta opción sólo para uno de los tipos de movimiento).",
    note_for_delete_supply_usage: "Deberá generar manualmente un movimiento de inventario de entrada para ingresar nuevamente la cantidad de insumos.",
    select_month: "Seleccione un mes",
    month: "Mes",
    daily_route_subtitle: "Establezca la programación para el personal, así puede construir rutas para la ejecución de las órdenes de servicio.",
    is_private_complement: "Sólo el creador podrá modificar este elemento (click para cambiar configuración).",
    is_public_complement: "Puede ser modificado por cualquier otro usuario (click para cambiar configuración).",
    form_pages: "Páginas del formulario",
    form: "Formulario",
    data_protection_policy: "En cumplimiento de lo previsto de la ley 1581 de 2012, sus decretos reglamentarios y demás normas concordantes, los datos personales aquí suministrados serán tratados de acuerdo a la política de protección de datos personales. La cual podrá visualizar en nuestro sitio web https://www.centecaribe.com.co/politica-privacidad.html.",
    color_explanation_complement_event_type: "los tipos de orden de servicio",
    color_explanation_complement_operative_area: "las áreas operativas",
    profile_assignment_information: "El perfil determina las restricciones que tendrá el usuario en los diferentes módulos de la aplicación.",
    initial_status_selection_info: "El estado inicial se asignará automáticamente durante la creación de las órdenes de servicio.",
    only_web: "Sólo Web",
    info_dynamic_form_on_status_change: "Al asignar un formulario dinámico, obligamos su diligenciamiento desde la App móvil al intentar realizar el cambio de estado.",
    supplies_report: 'Reporte de insumos',
    event_detail_description: "Aquí encontrará toda la información relacionada a la ejecución de la orden de servicio, así mismo, podrá modificar o agregar información hasta que la orden sea finalizada.",
    notes_description: "En esta sección encontrará notas relacionadas con la orden de servicio y sus evidencias.",
    note: "Nota",
    newnesses_description: "En este apartado encontrará todas las novedades reportadas por el personal asignado a la orden de servicio.",
    register: "Registrar",
    providers: "Proveedores",
    edit_provider: "Editar proveedor",
    providers_description: "Administre la información de los proveedores de insumos de su empresa.",
    new_provider: "Nuevo proveedor",
    provider: "Proveedor",
    inventory_movement: "Movimiento de inventario",
    no_data_to_print: "No hay datos para imprimir",
    warning_output_inventory_movement_for_warehouse: "Se generará únicamente el movimiento de salida del inventatio, si se desea ingresar los insumos nuevamente al inventario, se deberá realizar un movimiento de entrada manualmente.",
    order_has_been: "La orden de servicio se encuentra %s1",
    warning_warehouse_usage: "Se utilizará la bodega: '%s1'.",
    general_inventory: "Inventario general",
    service_order_updated: "Orden de servicio actualizada correctamente.",
    info: "Información",
    there_is_no_supplies_on_warehouse: "No hay insumos en bodega.",
    branches: "Sucursales",
    info_client_branches: "Registre las diferentes sucursales pertenecientes al cliente.",
    new_branch: "Nueva sucursal",
    edit_branch: "Editar sucursal",
    branch: "Sucursal",
    select_branch_message: "El cliente seleccionado tiene sucursales, por favor seleccione una o indique si desea utilizar la información de la sede principal.",
    i_want_to_use_main_address: 'Usar la dirección principal',
    no_warehouses_for_supply_item: "El insumo no se encuentra asignado a ninguna bodega.",
    no_inventory_movements_for_supply: "No se han realizado movimientos de inventario.",
    movement_type_not_selected: "No se ha seleccionado el tipo de movimiento.",
    request_types_complement: "los tipos de solicitud",
    request_types: "Tipos de solicitud general",
    request_types_description: "Administre los diferentes tipos de solicitud general que se podrán generar para que sean gestionadas.",
    edit_request_type: "Editar tipo de solicitud",
    new_request_type: "Nuevo tipo de solicitud",
    request_type: "Tipo de solicitud",
    main_menu_general_request: "Solicitudes",
    days_until_warning: "Días límite para estado de advertencia",
    days_until_error: "Días límite para estado de emergencia",
    general_requests: "Solicitudes generales",
    general_requests_subtitle: "Las solicitudes generales le permitirán hacer requerimientos a su equipo de trabajo, validar su cumplimiento y cambiar su estado en cualquier momento.",
    general_requests_description: "Realice solicitudes de diferentes tipos a su equipo de trabajo.",
    my_requests: "Mis solicitudes",
    requests_assigned_to_me: "Solicitudes asignadas a mí",
    request_status_pending: "Pendiente",
    request_status_in_progress: "En progreso",
    request_status_done: "Finalizada",
    request_status_not_finished: "No finalizada",
    bills: "Facturas",
    daysToShowEvents: "Días para mostrar órdenes en móvil",
    daysToShowEventsDescription: "Especifica la cantidad de días antes para mostrar las órdenes de servicio en la app móvil.",
    new_request: "Nueva solicitud",
    edit_request: "Editar solicitud",
    created_by: "Creado por",
    request: "Solicitud",
    notes: "Notas",
    request_notes_description: "Notas relacionadas a la ejecución de la solicitud.",
    no_notes: "Sin notas",
    requests_status_change_description: "Cambios de estado que especifican la ejecución de la solicitud.",
    no_status_changes: "Sin cambios de estado",
    add_note: "Agregar nota",
    only_for_assigned_to_me_list: "Sólo aplica para el listado de 'Solicitudes asignadas a mí'.",
    only_for_my_requests_list: "Sólo aplica para el listado de 'Mis solicitudes",
    no_notifications: "Sin notificaciones.",
    notifications: "Notificaciones",
    see_more: "Ver más",
    see_less: "Ver menos",
    mandatory_values_warning: "Todos los valores marcados con asterisco (*) son obligatorios.",
    no_evidences: "No hay evidencias",
    no_restrictions: "Sin restricciones",
    assign_order_info: "Ingrese el número de la orden que desea relacionar a la pre-orden seleccionada, el número de orden lo puede identificar en el detalle de la orden.",
    info_code_creation: "Si no ingresa un código, éste se generará automáticamente.",
    info_supply_adding_to_event: "Al agregar un insumo a la orden de servicio, se deberá aprobar para generar la salida de inventario automáticamente.",
    info_approved_additional_cost: "Al aprobar un costo adicional, su valor se sumará al total del valor de la orden de servicio.",
    warning_rejected_additional_cost: "Al rechazar un costo adicional, su valor NO se tendrá en cuenta.",
    put_files_here: "Arrastra y arroja tus archivos de evidencia aquí.",
    drop_files_here: "Suelte el/los archivo(s) aquí.",
    delete_all: "Eliminar todo",
    files_to_upload: "Evidencias a cargar.",
    upload_files: "Subir archivo(s)",
    complianceText: "Texto de aceptación",
    create_service_order: "Crear orden de servicio",
    question_create_order_from_preorder: "¿Desea generar una orden de servicio a partir de los datos de la pre-orden",
    info_month_change_home: "Seleccione el mes del cual quiere obtener las estadísticas, para el mes en curso se mostrará la información desde el primer día del mes hasta la fecha actual.",
    notify_status_change: "Se generará una notificación cada vez que una orden de servicio llegue a este estado.",
    notity_by_email_status_change: "Se generará un correo electrónico cada vez que una orden de servicio llegue a este estado.",
    user_to_notify_note: "Para ingresar más de un usuario utilice punto y coma (;).",
    users: "Usuario(s)",
    notify_only_defined_user: "Enviar notificación sólo a los usuarios especificados.",
    notify_event_type: "Se generará una notificación cada vez que se cree una orden de servicio de este tipo.",
    notify_inventory_movement_type: "Se generará una notificación cada vez que se cree un movimiento de inventario de este tipo.",
    notify_additional_cost_type: "Se generará una notificación cada vez que se agregue un costo adicional de este tipo a una orden de servicio.",
    set_password: "Cambiar contraseña",
    profile_notification_info: "Especifique cuáles notificaciones desea recibir (dependerá de la configuración establecida para cada tipo).",
    notify_order_creation: "Creación de órdenes de servicio",
    notify_order_creation_by_type_info: "Notifica la creación de órdenes de servicio (dependiendo de si el tipo de orden está marcado para notificar).",
    notify_status_change_info: "Notifica cuando se realiza un cambio de estado en una orden de servicio (depende de si el estado está marcado para notificar).",
    notify_inventory_movement_info: "Notifica cuando se crea un movimiento de inventario (depende de si el tipo de movimiento está marcado para notificar).",
    notify_additional_cost_info: "Notifica cuando se agrega un costo adicional a una orden de servicio (depende de si el tipo de costo adicional está marcado para notificar).",
    notify_newness_info: "Notifica cuando el personal registra una novedad durante la ejecución de una orden de servicio.",
    vehicle_assignment: "Asignación de vehículo",
    notify_vehicle_assignment_info: "Notifica cuando se realice la asignación de un vehículo.",
    notify_pre_order_info: "Notifica cuando se crea una pre-orden.",
    notify_general_request_info: "Notifica cuando se crea una solicitud general y cuando se realizan le cambios de estado.",
    information_saved_successfully: "Configuración guardada correctamente.",
    current_password: "Contraseña actual",
    new_password: "Nueva contraseña",
    do_not_forget_to_logout_to_apply_change: "No olvide cerrar sesión para aplicar el cambio.",
    next_to_be_delayed: "Próximo a atrasarse",
    delayed: "Atrasado",
    on_time: "A tiempo",
    select_columns_for_report: "Seleccione las columnas",
    unselect_all_columns: "Deseleccionar todas las columnas",
    select_all_columns: "Seleccionar todas las columnas",
    visible_on_mobile_info: "El campo podrá ser diligenciado desde la App móvil.",
    mandatory_info: "El campo debe ser diligenciado para finalizar el formulario (Aplica para la App móvil).",
    export: "Exportar",
    CSV: "CSV",
    no_data_to_export: "No hay datos para exportar.",
    select_separator: "Seleccione el separador",
    select_separator_Description: "El separador es el caracter utilizado para dividir cada valor en un set de datos.",
    comma_separator: "Coma (,)",
    semicolon_separator: "Punto y coma (;)",
    colon_separator: "Dos Puntos (:)",
    tab_separator: "Tabulador (TAB)",
    custom: "Personalizado",
    enter_separator: "Ingresa el separador",
    real_income: "Ingreso real",
    total_event: "Total orden de servicio",
    main_warehouse: "Bodega principal",
    unassign: "Desasignar",
    select_all: "Seleccionar todo",
    unselect_all: "Deseleccionar todo",
    report_types: "Tipos de reporte",
    new_report_type: "Nuevo tipo de reporte",
    report_types_description: "Configure los diferentes tipos de reporte que pueden ser generados para cada una de las órdenes de servicio.",
    configure_report: "Configurar reporte",
    edit_report_type: "Editar tipo de reporte",
    report_type: "Tipo de reporte",
    edition_level: "Nivel de edición",
    search_event_by_code: "Buscar orden de servicio por código.",
    events_by_type: "Órdenes de servicio por tipo de orden",
    charts_visibility_title: "Mostrar / ocultar gráficas",
    no_data_on_form_page: "No hay datos registrados para la página actual",
    client_search_tooltip: "Buscar un cliente por tipo de identificación e identificación.",
    found_client_warning: "La información cargada pertenece a un cliente existente, si guarda la información sin modificarla, podría duplicarla.",
    contractor_search_tooltip: "Buscar contratista por tipo de identificación e identificación.",
    personal_search_tooltip: "Buscar personal por tipo de identificación e identificación.",
    found_contractor_warning: "La información cargada pertenece a un contratista existente, si guarda la información sin modificarla, podría duplicarla.",
    found_personal_warning: "La información cargada pertenece a un personal existente, si guarda la información sin modificarla, podría duplicarla.",
    events_by_proceeding: "Órdenes de servicio por expediente",
    info_attention_days: "Que se asignarán automáticamente entre la fecha estimada de atención inicial y la final.",
    attention: "Atención",
    attention_days: "Días de atención",
    event_red_semaphore: "Para indicar que la orden de servicio está atrasada.",
    event_yellow_semaphore: "Para indicar que la orden de servicio está próxima a atrasarse.",
    event_green_semaphore: "Cantidad de días que indican que la orden de servicio está a tiempo.",
    days_quantity: "Cantidad de días",
    supply_usage_status_change_title: "Cambio de estado del uso de insumo",
    warning_output_inventory_movement: "Al aprobar el uso del insumo, se generará automáticamente el movimiento de inventario de salida con la cantidad asignada.",
    warning_output_inventory_movement_rejected: "Al rechazar el uso del insumo, el inventario no será afectado.",
    add_client: "Crear cliente junto a la orden de servicio.",
    cancel_client_creation: "Cancelar creación de cliente",
    approved_quantity: "Cantidad aprobada",
    not_enough_quantity: "No hay la cantidad suficiente para el insumo, sólo podrá solicitar un máximo de %s.",
    supply_request_title: "Solicitud de repuestos",
    supply_request_description: "Valide las diferentes solicitudes de repuestos creadas para las diferentes órdenes de servicio y defina su estado.",
    supply_request_menu: "Solicitud de insumos",
    supply_request_view: "Ver solicitud",
    supply_request_change_status: "Cambiar estado",
    payment_to_technician_request_title: "Solicitud de pago al personal",
    payment_to_technician_request_description:
      "Valide las diferentes solicitudes de pago al personal creadas para las distintas órdenes de servicio y defina su estado.",
    payment_to_technician_request_menu: "Solicitud de pago al personal",
    payment_to_technician_request_view: "Ver solicitud",
    change_payment_to_technician_status: "Cambiar estado del pago",
    request_status: "Estado de solicitud",
    supply_requests: "Solicitud de insumos",
    additional_cost_request_title: "Solicitud de costos adicionales",
    additional_cost_request_description: "Valide las diferentes solicitudes de costos adicionales creadas para las diferentes órdenes de servicio y defina su estado.",
    additional_cost_request_menu: "Solicitud de costos adicionales",
    additional_cost_request_view: "Ver solicitud",
    additional_cost_requests: "Solicitud de costos adicionales",
    error_max_file_size: "El archivo excede el tamaño máximo permitido (3 MB)",
    report_title: "Título del reporte",
    evidence_columns: "Cantidad de columnas para evidencias",
    evidence_columns_description: "Indica el número de columnas para mostrar las evidencias en el reporte.",
    show_only_unread_notifications: "Mostrar sólo notificaciones sin leer",
    form_results_two_columns: "2 Columnas",
    form_results_single_column: "Columna única",
    form_results_format: "Formato de formularios",
    additional_setup: "Configuración adicional",
    form_results_format_description: "Especifica la forma como se mostrarán los valores para los campos de los formularios.",
    hide_modification_data: "Ocultar datos de modificación",
    hide_modification_data_description: "No se mostrará el texto de modificado por en los formularios ni en las evidencias.",
    hidden: "Oculto",
    visible: "Visible",
    without_contractor: "Sin contratista",
    show_report_header: "Mostrar datos en encabezado de reporte",
    report_header: "Encabezado de reporte",
    show_name: "Mostrar nombre",
    show_identification: "Mostrar identificación",
    show_address: "Mostrar dirección",
    show_phone_number: "Mostrar teléfono",
    show_email: "Mostrar correo electrónico",
    show_logo: "Mostrar logo",
    upload_logo: "Cargar logo",
    delete_logo: "Eliminar logo",
    use_contractor_header: "Usar encabezado de contratista",
    use_contractor_header_description: "En el encabezado del reporte se mostrará la información del contratista asignado a la orden de servicio, incluyendo el logo registrado.",
    general: "General",
    section: "Sección",
    set_section: "Asignar sección",
    sections: "Secciones",
    section_saved_successfully: "¡Sección guardada correctamente!",
    error_saving_section: "Error al guardar la sección",
    delete_section: "Eliminar sección",
    delete_section_confirmation: "¿Está seguro que desea eliminar esta sección?",
    audio_and_video: "Audio y Video",
    general_requests_description_on_event_detail: "En esta sección encontrará solicitudes relacionadas con la orden de servicio.",
    visible_on_report: "Visible en reporte",
    invisible_on_report: "Invisible en reporte",
    click_to_change: "Click para cambiar",
    finish_concept: "Concepto de finalización",
    replace_service_value: "Reemplaza valor de servicio",
    edit_finish_concept: "Editar concepto de finalización",
    finish_concept_description: "Permite definir el concepto final de la ejecución de una órden de servicio, este concepto puede afectar el valor final del servicio, reemplazándolo.",
    new_finish_concept: "Nuevo concepto de finalización",
    replace_service_value_Description: "Al asignar este concepto de finalización a una orden de servicio, el valor del servicio será reemplazado por el valor asignado.",
    warning_service_value_replacement: "El valor final del servicio será de:",
    editable: "Editable",
    non_editable: "No editable",
    outcomes: "Egresos",
    location: "Ubicación",
    contact: "Contacto",
    assignment: "Asignación",
    dates: "Fechas",
    time_distribution: "Distribución de tiempo de ejecución",
    filter: "Filtro",
    actions: "Acciones",
    action_create: "Crear",
    action_modify: "Modificar",
    action_delete: "Eliminar",
    action_service_value_change: "Cambio de valor de servicio",
    action_service_assignment: "Asignación de servicio",
    action_billing: "Facturación",
    action_service_payment_registration: "Registro de pago de servicio",
    action_personal_payment_registration: "Registro de pago a personal",
    action_personal_payment_approval: "Aprobación de pago a personal",
    action_supply_approval: "Aprobación de insumos",
    action_status_change: "Cambio de estado",
    action_status_change_form_modification: "Modificación de formulario de cambio de estado",
    action_add_evidences: "Agregar evidencias",
    action_delete_evidences: "Eliminar evidencias",
    action_download_evidences: "Descargar evidencias",
    action_add_notes_to_evidences: "Agregar notas a evidencias",
    action_add_additional_costs: "Agregar costos adicionales",
    action_additional_costs_approval: "Aprobación de costos adicionales",
    action_report_modification: "Modificación de informe",
    action_add_notes: "Agregar notas",
    action_vehicle_assignment: "Asignación de vehículo",
    action_profile_assignment: "Asignación de perfil",
    action_user_change: "Cambio de usuario",
    action_password_change: "Cambio de contraseña",
    action_settlement_status_change: "Cambiar estado",
    module_actions: "Acciones del módulo",
    special_permissions: "Restricciones especiales",
    request_date: "Fecha de solicitud",
    answer_to_request: "Responder a solicitud",
    detail: "Detalle de la liquidación",
    new_settlement_req_additional_costs: "Las órdenes de servicio deben tener los costos adicionales ya relacionados y aprobados.",
    new_settlement_req_service_type_payment_type: "Los tipos de servicio deben contar con tipos de pago asociados.",
    new_settlement_req_generated_status: "Se tendrán en cuenta los pagos a personal registrados en las órdenes de servicio con el estado 'Generado'.",
    personal_assigned: "Personal asignado",
    text: "Texto",
  },
});

export default localize;
